enum MailTipsXMLElements {
    // Custom Mail Tip
    CustomMailTip = 'CustomMailTip',

    // Restricted permission
    DeliveryRestricted = 'DeliveryRestricted',

    // External member count
    ExternalMemberCount = 'ExternalMemberCount',

    // Guest Mail Tip status
    GuestMailTipStatus = 'GuestMailTipStatus',

    // If it is moderated
    IsModerated = 'IsModerated',

    // If Mailbox is full
    MailboxFull = 'MailboxFull',

    // Maximum size of the message
    MaxMessageSize = 'MaxMessageSize',

    // Out of Office
    OutOfOffice = 'OutOfOffice',

    // Whether recipient prefers accessible content
    PreferAccessibleContent = 'PreferAccessibleContent',

    // Recipient Address
    RecipientAddress = 'RecipientAddress',

    // Total member count
    TotalMemberCount = 'TotalMemberCount',
}

export default MailTipsXMLElements;
